import { ReactNode } from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import KpiBigNumber from './KpiBigNumber'
import InfoTooltip from './InfoTooltip'

interface OpenSingleCardProps {
  title: string
  value: ReactNode | null
  typeAccentColor?: string
  variant?: 'compact' | 'wall'
  info?: string
  onClick?: () => void
}

function OpenSingleCard({ title, value, typeAccentColor, variant = 'compact', info, onClick }: OpenSingleCardProps) {
  const isWall = variant === 'wall'
  return (
    <Paper
      elevation={1}
      sx={{
        p: isWall ? { xs: 2, md: 3 } : 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderLeft: typeAccentColor ? `4px solid ${typeAccentColor}` : undefined,
      }}
    >
      <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', mb: 2 }}>
        <Typography
          variant={isWall ? undefined : 'h6'}
          sx={{ fontSize: isWall ? 'clamp(1.25rem, 2vw, 2.25rem)' : undefined, fontWeight: 600 }}
        >
          {title}
        </Typography>
        {info && !isWall && <InfoTooltip text={info} />}
      </Stack>
      <Box sx={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr' }}>
        <KpiBigNumber label="Åpne" value={value} variant={variant} onClick={onClick} />
      </Box>
    </Paper>
  )
}

export default OpenSingleCard
